import React from 'react'
import Link from 'gatsby-link'

import fg from 'react-flexgrid'
import vinylPic from '../images/vinyl-records.jpg'
import pic02 from '../images/pic02.jpg'
import pic03 from '../images/pic03.jpg'
import get from 'lodash/get'

class Main extends React.Component {

  render() {

    var vinylData = this.props.vinylData;
    const { Grid, Row, Col } = require('react-flexgrid');
    console.log(fg);
    const renderAlbums = vinylData.map((album) => {
      return (<div key={`dan-${album.node.id}`} className="album">
        {/* <grid2>
          <Row>
            <Col xs={12} sm={3} md={2} lg={1} >{album.node.name}</Col>
            <Col xs={6} sm={6} md={8} lg={10} >{album.node.lastname}</Col>
            <Col xs={6} sm={3} md={2} lg={1} >{album.node.year}</Col>
          </Row>
        </grid2> */}
        {/* <table>
          <tr>
            <td>{album.node.name}</td>
            <td>{album.node.lastname}</td>
            <td>{album.node.album}</td>
            <td>{album.node.year}</td>
          </tr>
        </table> */}


        <span >{album.node.name} {album.node.lastname} - {album.node.album} ({album.node.year})</span>
      </div>);

    });

    // var text = "";
    // var i;
    // for (i = 0; i < vinylData.length; i++) {
    //   text += vinylData[i].node.name + " " + vinylData[i].node.lastname + " - " + vinylData[i].node.album;
    // }



    let close = <div className="close" onClick={() => { this.props.onCloseArticle() }}></div>


    return (
      <div id="main" style={this.props.timeout ? { display: 'flex' } : { display: 'none' }}>

        <article id="Vinyl" className={`${this.props.article === 'Vinyl' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{ display: 'none' }}>
          <h2 className="major">Vinyl</h2>
          <span className="image main"><img src={vinylPic} alt="" /></span>
          {renderAlbums}
          {close}
        </article>

        <article id="Musical_Electronics" className={`${this.props.article === 'Musical_Electronics' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{ display: 'none' }}>
          <h2 className="major">Musical Electronics</h2>
          <span className="image main"><img src={pic02} alt="" /></span>
          <p>Start</p>

          {close}
        </article>

        <article id="about" className={`${this.props.article === 'about' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{ display: 'none' }}>
          <h2 className="major">About</h2>
          <span className="image main"><img src={pic03} alt="" /></span>
          <p>Lorem ipsum dolor sit amet, consectetur et adipiscing elit. Praesent eleifend dignissim arcu, at eleifend sapien imperdiet ac. Aliquam erat volutpat. Praesent urna nisi, fringila lorem et vehicula lacinia quam. Integer sollicitudin mauris nec lorem luctus ultrices. Aliquam libero et malesuada fames ac ante ipsum primis in faucibus. Cras viverra ligula sit amet ex mollis mattis lorem ipsum dolor sit amet.</p>
          {close}
        </article>

        <article id="contact" className={`${this.props.article === 'contact' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{ display: 'none' }}>
          <h2 className="major">Contact</h2>
          <form method="post" action="#">
            <div className="field half first">
              <label htmlFor="name">Name</label>
              <input type="text" name="name" id="name" />
            </div>
            <div className="field half">
              <label htmlFor="email">Email</label>
              <input type="text" name="email" id="email" />
            </div>
            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea name="message" id="message" rows="4"></textarea>
            </div>
            <ul className="actions">
              <li><input type="submit" value="Send Message" className="special" /></li>
              <li><input type="reset" value="Reset" /></li>
            </ul>
          </form>
          <ul className="icons">
            <li><a href="#" className="icon fa-twitter"><span className="label">Twitter</span></a></li>
            <li><a href="#" className="icon fa-facebook"><span className="label">Facebook</span></a></li>
            <li><a href="#" className="icon fa-instagram"><span className="label">Instagram</span></a></li>
            <li><a href="#" className="icon fa-github"><span className="label">GitHub</span></a></li>
          </ul>
          {close}
        </article>

      </div>
    )
  }
}

Main.propTypes = {
  route: React.PropTypes.object,
  article: React.PropTypes.string,
  articleTimeout: React.PropTypes.bool,
  onCloseArticle: React.PropTypes.func,
  timeout: React.PropTypes.bool
}

export default Main


// WEBPACK FOOTER //
// ./src/components/Main.js